export default "__VITE_ASSET__duKAHzUq__"